const urls = {
    home: '/',
    login: '/login',
    register: '/register',
    page: '/p',
    loginParts: {
        accessCode: 'code',
        role: 'role',
        forgotPassword: 'forgotPassword',
        resetPassword: 'resetPassword',
        student: 'student',
    },
    logout: '/logout',
    studentCode: {
        home: '/sc',
        parts: {
            skill: 'skill',
            task: 'task',
        },
    },
    preview: {
        home: '/preview', // {taskId}
        // program: '/preview/p', // {programId}/{moduleIndex?}/{taskIndex?}
        // module: '/preview/m', // {moduleId}/{taskIndex?}
        // task: '/preview/t', // {taskId}
    },

    public: {
        home: '/public',
        program: '/public/p', // {programId}/{moduleIndex?}/{taskIndex?}
        module: '/public/m', // {moduleId}/{taskIndex?}
        programLink: '/public/link', // page for id lookup and redirect to program or module
    },
    inside: {
        home: '/inside',
        dashboard: '/inside/home',
        page: '/inside/page',
        form: '/inside/form',
        users: {
            home: '/inside/users',
            new: '/inside/users/new',
        },
        resource: {
            home: '/inside/res',
            module: '/inside/res/m',
            task: '/inside/res/p',
        },
        profile: '/inside/profile',
        school: {
            home: '/inside/school',
            new: '/inside/school/new',
        },
        student: {
            home: '/inside/student',
            new: '/inside/student/new',
            parts: {
                about: 'about',
                skills: 'skills',
                plan: 'plan',
                week: 'week',
                today: 'today',
                edit: 'edit',
                task: 'task',
                progress: 'progress',
            },
        },
        program: {
            home: '/inside/program',
            skill: '/inside/program/skill',
            methods: '/inside/program/methods',
            research: '/inside/program/research',
            page: '/inside/program/page',
            parts: {
                module: 'module',
                task: 'task',
            },
        },
    },
};

export default urls;
